/*
This function parses decimal hours input into string with hours and minutes.
Example:
Input: 12.75
Output: 
12h 45m - isExpanded = false
12 hours 45 minutes - isExpanded = true
 */
const parseHours = (hoursDecimal, isExpanded = false) => {
  const hours = `${Math.floor(hoursDecimal)}${isExpanded ? " hours" : "h"}`;
  const minutes = `${Math.floor(
    (hoursDecimal - Math.floor(hoursDecimal)) * 60.0
  )}${isExpanded ? " minutes" : "m"}`;
  return `${hours} ${minutes}`;
};

/* Decimal hours from Profile are rounded up to 2 decimal places, which can produce rounding errors
 * when these are summed and displayed.
 * For example 6h 5m will be returned from Profile as 6.09 (which is 5.4 minutes)
 * 7h 10m will be returned as 7.17 (which is 10.2 minutes)
 * When adding these together you can get extra minutes appear out of thin air
 * This function takes a decimal hours input and returns the same time rounded down to the nearest
 * whole minute
 * e.g. 6.09 => 6.0833333333333333
 */
const roundDownToWholeMinutes = hoursDecimal => {
  const ONE_MINUTE = 1 / 60;
  const hours = Math.floor(hoursDecimal);
  const minutes = Math.floor((hoursDecimal - hours) / ONE_MINUTE) * ONE_MINUTE;
  return hours + minutes;
};

export { parseHours, roundDownToWholeMinutes };
